<template>
  <div class="container">
    <v-row>
      <iframe
        v-show="loaded"
        id="fivedegreesLoanDocs"
        width="100%"
        style="border: none;"
        :src="loanUrl"
        frameborder="0"
      ></iframe>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useAuthStore } from '@/stores/useAuthStore';
import { getFiveUrl } from '@/utils/fiveDegreesUtils'
import axios from 'axios'

const loaded = ref(false)
const loanUrl = ref('https://lanavefur.gildi.is')
const authStore = useAuthStore()

onMounted(async () => {
  loaded.value = false

  try {
    const token = await authStore.loginLibra()
    await axios.post(`${getFiveUrl()}/Notandi/JwtToken/`, null, {
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
    })

    setTimeout(() => {
      loanUrl.value = `${getFiveUrl()}/customer-documents`
      loaded.value = true
    }, 0)
  } catch (error) {
    console.error('Failed to load iframe auth', error)
  }
})
</script>

<style scoped>
iframe {
  width: 1px;
  min-width: 100%;
  min-height: 1100px;
}
</style>
